export enum CalendarViewType {
    GRID = 1,
    LIST = 2,
}
